import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import { I18n } from 'aws-amplify'

import ChangePassword from '../../../../../presentation/pages/common/amplify/change-password'

import HelperAmplify from '../../../../../presentation/helpers/helper-amplify'

const MakeChangePassword = () => {
  document.title = 'BuscarMédico - Alterar senha'

  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const history = useHistory()
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const dataForm = [
    {
      items: [
        {
          name: 'oldPassword',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Senha atual',
          label: 'Senha atual',
          required: true,
        },
        {
          name: 'newPassword',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Nova senha',
          label: 'Nova senha',
          required: true,
          secureTextEntry: true,
          passwordInput: true,
        },
        {
          name: 'confirmNewPassword',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Confirmar nova senha',
          label: 'Confirmar nova senha',
          required: true,
          secureTextEntry: true,
          passwordInput: true,
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Enviar',
          submittingText: 'Enviando...',
        },
      ],
    },
  ]

  const toggleVisibility = (value?: boolean): void => {
    setIsVisible(value || !isVisible)
  }

  const handleSubmit = async (values: any): Promise<void> => {
    const { oldPassword, newPassword, confirmNewPassword } = values

    if (oldPassword === newPassword) {
      setErrorMessage('A nova senha não pode ser igual a senha atual')
      return
    }

    if (newPassword !== confirmNewPassword) {
      setErrorMessage('A nova senha não confere com a confirmação')
      return
    }

    try {
      await HelperAmplify.changePassword(oldPassword, newPassword)
      setErrorMessage(null)
      toggleVisibility(true)
      history.goBack()
    } catch (error: any) {
      const msg = I18n.get(error.name)
      setErrorMessage(msg)
    }
  }

  const changePasswordProps = {
    dataForm,
    onSubmit: handleSubmit,
    errorMessage,
    isVisible,
    toggleVisibility,
  }

  return <ChangePassword {...changePasswordProps} />
}

export default MakeChangePassword
